import React, { useState, useEffect } from "react";
import "./PayrollAdminModal.scss";
import {
  changeUserDetails,
  userAddUpdateAppAccess,
  changemmerchantdetails,
  updateUserEmail,
} from "../../util/API/admin";
import { AssignDeassignRoles } from "../../util/API/admin";
import {
  Box,
  MenuItem,
  Select,
  TextField,
  Typography,
  InputLabel,
  Chip,
  Autocomplete,
  Grid,
  Divider,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import BaseCard from "../UI/BaseCard/BaseCard";
import BaseButton from "../UI/BaseButton/BaseButton";
import { useSelector } from "react-redux";

import {
  getOptionsForSelect,
  setAsArray,
} from "../../util/utilfunctions/utilFunctions";
import { stateData } from "../../constants/countrylist";
import {
  getCardholderemessages,
  getCardholdermessages,
} from "../../util/API/customers";
import UserEmailTable from "../UserEmailTable/UserEmailTable";
import SMStable from "../SMSTable/SMStable";
import { commonRunQuery, GetUserExternalRef, DeleteUserExternalRef } from "../../util/API/loans";
import BaseModal from "../UI/BaseModal/BaseModal";
import { GetMerchantProfile } from "../../util/API/batch";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      {...other}
      className="tab-panel-container"
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}
function PayrollAdminModal({
  open,
  handleClose,
  selectedUser,
  updateUser,
  setUpdateUser,
  userStatus,
  userRoles,
  payrollUsers,
  handleSelectedUser,
}) {

  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    telephoneno: "",
    status: "",
    countryid: "",
    stateid: "",
    otherNames: "",
    role: "" // Company Name
  });
  const [loading, setLoading] = useState(false);
   const handleReEnableMFA = async (userid) => {
  setLoading(true);
  try {
    const externalRefResponse = await GetUserExternalRef(userid, "19");
    const refid = externalRefResponse?.data?.body?.refid;

    if (!refid) {
      console.warn("No MFA record found for userid:", userid); // ← silent
      return;
    }

    const deleteResponse = await DeleteUserExternalRef(refid);

    if (deleteResponse?.data?.header?.callStatus == "1") {
      console.log("MFA reset successfully for userid:", userid); // ← silent
    } else {
      console.error("MFA reset failed:", deleteResponse?.data?.header?.msg);
    }

  } catch (err) {
    console.error("handleReEnableMFA error============", err);
  } finally {
    setLoading(false);
  }
};
  const [role, setRole] = useState("");
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "error",
    header: "",
    message: "",
  });
  const [stateOptions, setStateOptions] = useState([
    { key: "not-available", value: "not-available", label: "Not Available" },
  ]);
  let configVariables = useSelector((state) => state.config.baseConfig);
  const [isLoading, setIsLoading] = useState(true);
  const [value, setValue] = useState(0);
  const [showData, setShowData] = useState("SMS");
  const [emailData, setEmailData] = useState([]);
  const [smsData, setSMSData] = useState([]);
  const [appsList, setAppsList] = useState([]);
  const [selectedAppId, setSelectedAppId] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [roleToDelete, setRoleToDelete] = useState(null);
  const [initialOtherNames, setInitialOtherNames] = useState("");
  //NCS-1993
  const [companyNameError, setCompanyNameError] = useState("");
  const [initialEmail, setInitialEmail] = useState("");

  let isAdmin = sessionStorage.getItem("isAdmin");
  const userRoleId = sessionStorage.getItem("userSecurityRoleId");
  const associatePayrollAdminId  = configVariables.associatePayrollAdminId
  const externalPayrollAdminId  = configVariables.payRollAdminId
const isAssocitePayrollAdmin = Array.isArray(selectedUser?.["Securityuserrole"])
  ? selectedUser["Securityuserrole"].some(
      (r) => String(r.roleid) === associatePayrollAdminId,
    )
  : String(selectedUser?.["Securityuserrole"]?.roleid) ===
    associatePayrollAdminId;
    const isExternalPayrollAdmin = Array.isArray(selectedUser?.["Securityuserrole"])
  ? selectedUser["Securityuserrole"].some(
      (r) => String(r.roleid) === externalPayrollAdminId,
    )
  : String(selectedUser?.["Securityuserrole"]?.roleid) ===
    externalPayrollAdminId;
  const authUser = sessionStorage.getItem("user");
  const parsedAuthUser = JSON.parse(authUser);

  useEffect(() => {
    const updateStates = () => {
      const country = userData.countryid;
      if (!country || country === "na") {
        setStateOptions([
          {
            key: "not-available",
            value: "not-available",
            label: "Not Available",
          },
        ]);
        return;
      }
      const countryInfo = stateData.find((c) => c.iso3 === country);
      const states = countryInfo?.states || [];
      const mapped = states.length
        ? states.map((s) => ({
            key: s.state_code,
            value: s.state_code,
            label: s.name,
          }))
        : [
            {
              key: "not-available",
              value: "not-available",
              label: "Not Available",
            },
          ];
      setStateOptions(mapped);
    };
    updateStates();
  }, [userData.countryid]);
  useEffect(() => {
    if (value === 1) {
      getMessages();
    } else if (value === 2) {
      getAppsList();
    } else {
      setEmailData([]);
      setSMSData([]);
    }
  }, [value]);
  //NCS-1993
  const encodedLength = (str) => {
    if (!str) return 0;
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;").length;
  };
  const getAppsList = async () => {
    try {
      const response = await commonRunQuery(314, "");
      if (
        response?.data?.header?.callStatus == "1" &&
        parseInt(response?.data?.header?.reccount) > 0
      ) {
        const responseData = setAsArray(response?.data?.body?.record);
        const formattedApps = responseData.map((item) => ({
          label: item.apps.description + ` (${item.apps.appid})`,
          appid: item.apps.appid,
        }));
        setAppsList(formattedApps);
      }
    } catch (error) {
      console.log("getAppsList_error---------", error);
    } finally {
      setIsLoading(false);
    }
  };
  const getMessages = async () => {
    try {
      setIsLoading(true);
      let smsMessages = await getCardholdermessages(
        selectedUser?.User?.id,
        isAdmin,
      );
      let emailMessages = await getCardholderemessages(selectedUser?.User?.id);
      let emailRecord = [];
      if (Array.isArray(emailMessages?.data?.payload?.record)) {
        emailRecord = emailMessages?.data?.payload;
      } else {
        if (emailMessages?.data?.payload == "") {
          emailRecord = emailMessages?.data?.payload;
        } else {
          emailRecord["record"] = [emailMessages?.data?.payload?.record];
        }
      }
      if (smsMessages?.callStatus == 1) {
        setSMSData(smsMessages?.payload);
      }
      setEmailData(emailRecord);
    } catch (error) {
      console.log("getMessages_error===============", error);
    } finally {
      setIsLoading(false);
    }
  };
  function handleChange(evt) {
    const value = evt.target.value;
    setUserData({
      ...userData,
      [evt.target.name]: value,
    });
    //NCS-1993
    if (evt.target.name === "otherNames") {
      const len = encodedLength(value);
      setCompanyNameError(
        len > 60 ? `Company name is too long (max 60 characters)` : "",
      );
    }
  }
  useEffect(() => {
    const getPayrollAdminInfo = async () => {
      if (!selectedUser) return;
      //NCS-1993
      setCompanyNameError("");
      setUserData({
        firstName: "",
        lastName: "",
        email: "",
        telephoneno: "",
        status: "",
        countryid: "",
        stateid: "",
        otherNames: "",
      });
      setIsLoading(true); // Start loading
      const currentEmail =
        selectedUser["Useremailaccount"]?.emailAccount ||
        selectedUser["Vuser"]?.emailAccount ||
        "";

      let companyName = selectedUser["Vuser"]?.otherNames || "-";
      try {
        const profileRes = await GetMerchantProfile(
          "",
          selectedUser["Vuser"]?.id || selectedUser["User"]?.id,
        );
        if (profileRes?.callStatus === "1") {
          companyName = cleanCompanyName(
            profileRes.payload?.Merchant?.businessname,
          );
        }
      } catch (err) {
        console.error("Failed to fetch merchant profile:", err);
      }
      setUserData({
        firstName: cleanCompanyName(
          selectedUser["User"]?.firstName ||
            selectedUser["Vuser"]?.firstName ||
            "",
        ),
        lastName: cleanCompanyName(
          selectedUser["User"]?.lastName ||
            selectedUser["Vuser"]?.lastName ||
            "",
        ),
        // email: selectedUser['Useremailaccount']?.emailAccount || selectedUser['Vuser']?.emailAccount || "",
        email: currentEmail,
        telephoneno:
          selectedUser["User"]?.telephoneno ||
          selectedUser["Vuser"]?.telephoneno ||
          "",
        status:
          selectedUser["User"]?.status || selectedUser["Vuser"]?.status || "",
        countryid:
          selectedUser["User"]?.countryid ||
          selectedUser["Vuser"]?.countryid ||
          "",
        stateid:
          selectedUser["User"]?.stateid || selectedUser["Vuser"]?.stateid || "",
        otherNames: companyName, // Use fetched/cleaned company name
      });
      setInitialEmail(currentEmail);
      setRole(
        !Array.isArray(selectedUser["Securityuserrole"])
          ? selectedUser["Securityuserrole"].roleid
          : selectedUser["Securityuserrole"][0].roleid,
      );
      setInitialOtherNames(companyName);
      setIsLoading(false); // End loading
    };
    getPayrollAdminInfo();
  }, [selectedUser]);
  const assignDeassign = async (merchantid, roleid, action) => {
    const response = await AssignDeassignRoles(merchantid, roleid, action);
    handleSelectedUser(selectedUser["User"]?.id || selectedUser["Vuser"]?.id);
    return response;
  };
  const handleAddRole = async () => {
    if (role === "") return;
    let roleExists = false;
    if (Array.isArray(selectedUser["Securityuserrole"])) {
      roleExists = selectedUser["Securityuserrole"].some(
        (existingRole) => existingRole.roleid === role,
      );
    } else if (
      typeof selectedUser["Securityuserrole"] === "object" &&
      selectedUser["Securityuserrole"] !== null
    ) {
      roleExists = selectedUser["Securityuserrole"].roleid === role;
    }
    if (roleExists) {
      setAlert({
        ...alert,
        showAlert: true,
        message: "Cannot add role since it already exists.",
        severity: "error",
        header: "Error",
      });
      return;
    }
    const response2 = await assignDeassign(
      selectedUser["User"].id || selectedUser["Vuser"].id,
      role,
      1,
    );
    let callStatus3 =
      response2?.PartnerAddRemoveRoleClass?.data?.header?.callStatus;
    if (callStatus3 === "1") {
      setAlert({
        ...alert,
        showAlert: true,
        message: "Role added successfully.",
        severity: "success",
        header: "Success",
      });
    } else {
      setAlert({
        ...alert,
        showAlert: true,
        message: "Role could not be added. Please contact support.",
        severity: "error",
        header: "Error",
      });
    }
    payrollUsers();
  };
  const updateUserInfo = async (e) => {
    e.preventDefault();

    //  Add this email validation block
    if (!userData.email || userData.email.trim() === "") {
      setAlert({
        ...alert,
        showAlert: true,
        message: "Email field cannot be empty.",
        severity: "error",
        header: "Error",
      });
      return;
    }
    const isValidEmail = (email) => {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };
    if (!isValidEmail(userData.email)) {
      setAlert({
        ...alert,
        showAlert: true,
        message: "Please enter a valid email (e.g. name@example.com)",
        severity: "error",
        header: "Error",
      });
      return;
    }
    let allFieldsFilled = true;
    // const keysToExclude = [""];
    console.log("User Data ??????", userData);
    const listData = Object.keys(userData)
      .filter(
        (key) =>
          userData[key] !== undefined &&
          userData[key] !== null &&
          key.trim().toLowerCase() !== "role" &&
          key.trim().toLowerCase() !== "email",
      )
      .map((key) => {
        if (typeof userData[key] === "string" && userData[key].trim() === "") {
          allFieldsFilled = false;
          return null;
        }
        return `${key}|${userData[key]}`;
      })
      .filter((entry) => entry !== null)
      .join("/");
    if (!allFieldsFilled) {
      setAlert({
        ...alert,
        showAlert: true,
        message: "One or more fields are empty. All fields are required.",
        severity: "error",
        header: "Error",
      });
      return;
    }
    //NCS-1993
    if (encodedLength(userData["otherNames"]) > 60) {
      setCompanyNameError("Company name is too long ");
      setAlert({
        showAlert: true,
        message:
          "Company name cannot exceed 60 characters after accounting for special characters.",
        severity: "error",
        header: "Validation Error",
      });
      return;
    }
    const userid = selectedUser["User"].id || selectedUser["Vuser"].id;
    const response = await changeUserDetails(userid, listData);
    let callStatus = response?.payload?.callStatus;
    console.log("callStatus ????????", callStatus);
    if (callStatus === "1") {
      if (userData.otherNames !== initialOtherNames) {
        const merchantList = `businessname|${userData.otherNames}`;
        const merchantResponse = await changemmerchantdetails(
          userid,
          merchantList,
        );
        if (merchantResponse.data.header.callStatus !== "1") {
          setAlert({
            ...alert,
            showAlert: true,
            message: "Failed to update merchant profile.",
            severity: "error",
            header: "Error",
          });
          return;
        }
      }

      // Check if email has been updated BEFORE showing success alert

      if (userData.email !== initialEmail) {
        const assignedRoles = Array.isArray(selectedUser["Securityuserrole"])
  ? selectedUser["Securityuserrole"].map((r) => r.roleid)
  : selectedUser["Securityuserrole"]?.roleid
  ? [selectedUser["Securityuserrole"].roleid]
  : [];
        console.log('userData--------------->', userData)
        console.log("Email changed from", initialEmail, "to", userData.email);
        try {
          const updateEmailResponse = await updateUserEmail(
            userid,
            userData.email,
            userData.firstName,
            userData.lastName,
            parsedAuthUser?.userid,
            assignedRoles
          );
          console.log("updateEmailResponse---------", updateEmailResponse);

          const emailCallStatus =
            updateEmailResponse?.callStatus ??
            updateEmailResponse?.data?.callStatus;
          const emailAppID =
            updateEmailResponse?.AppID ?? updateEmailResponse?.data?.AppID;

          if (
            emailCallStatus === "0" &&
            emailAppID === "CheckEmailExistsClass"
          ) {
            setAlert({
              ...alert,
              showAlert: true,
              message:
                "Email already exists. Please use a different email address.",
              severity: "error",
              header: "Error",
            });
            return; // Stop here, no success alert, no refresh
          }
          console.log("Email updated — resetting MFA for userId:");
          try {
  await handleReEnableMFA(userid);
  console.log("MFA reset triggered after email update");
} catch (error) {
  console.error("MFA reset failed:", error);
}
        } catch (error) {
          console.error("updateUserEmail error:", error);
        }
      }

      // Only show success AFTER all updates (including email) have passed
      setAlert({
        ...alert,
        showAlert: true,
        message: "Payroll Admin information has been successfully updated.",
        severity: "success",
        header: "Success",
      });

      setTimeout(() => {
        setUpdateUser(!updateUser);
        payrollUsers();
      }, 2000);
    } else {
      setAlert({
        ...alert,
        showAlert: true,
        message: "Information could not be updated.",
        severity: "error",
        header: "Error",
      });
    }
    // payrollUsers();
    setTimeout(() => {
      setUpdateUser(!updateUser);
      payrollUsers();
      // If you want the modal to close automatically after the alert:
      // handleClose();
    }, 2000);
  };
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleTableChange = () => {
    setShowData(showData === "SMS" ? "email" : "SMS");
  };
  const handleAddAccess = async () => {
    try {
      const response = await userAddUpdateAppAccess(
        selectedUser?.User?.id || selectedUser["Vuser"]?.id,
        selectedAppId,
      );
      if (response?.data?.header?.callStatus == "1") {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "success",
          header: "Success",
          message: "Access granted successfully.",
        });
      }
    } catch (error) {
      console.log("handleAddAccess_error------------", error);
    }
  };
  const handleConfirmDelete = async () => {
    if (roleToDelete) {
      const response = await assignDeassign(
        selectedUser["User"].id || selectedUser["Vuser"].id,
        roleToDelete,
        0,
      );
      if (
        response?.PartnerAddRemoveRoleClass?.data?.header?.callStatus === "1"
      ) {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "success",
          header: "Success",
          message: "Role removed successfully",
        });
        payrollUsers();
      }
      setConfirmModalOpen(false);
      setRoleToDelete(null);
    }
  };
  let switchButtonText = showData === "email" ? "View SMS" : "View Emails";
  return (
    <BaseDrawer
      open={open}
      handleClose={() => {
        handleClose();
        setValue(0);
        setEmailData([]);
        setSMSData([]);
        setShowData("SMS");
      }}
      height="90vh"
      title={"Payroll Admin Profile Info"}
    >
      <Box sx={{ display: "flex", height: "100%" }}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleTabChange}
          sx={{
            borderRight: 1,
            borderColor: "divider",
            "& .MuiTabs-indicator": { backgroundColor: "#ff972c" },
            "& .MuiButtonBase-root.Mui-selected": { color: "#ff972c" },
            "& .MuiButtonBase-root": { color: "rgba(0, 0, 0, 0.87)" },
          }}
        >
          <Tab label="Personal Information" />
          <Tab label="Communications" />
        </Tabs>
        <TabPanel value={value} index={0}>
          <Box sx={{ overflowY: "auto", maxHeight: "calc(90vh - 20%)" }}>
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <BaseCard>
                <Box className="admin-details">
                  <form onSubmit={updateUserInfo}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                          }}
                        >
                          First Name
                        </InputLabel>
                        <TextField
                          type="text"
                          name="firstName"
                          value={userData.firstName}
                          onChange={handleChange}
                          fullWidth
                          sx={{
                            background: "white",
                            "& .MuiInputBase-root": {
                              maxHeight: "40px",
                              padding: "6px 10px",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                          }}
                        >
                          Last Name
                        </InputLabel>
                        <TextField
                          type="text"
                          name="lastName"
                          value={userData.lastName}
                          onChange={handleChange}
                          fullWidth
                          sx={{
                            background: "white",
                            "& .MuiInputBase-root": {
                              maxHeight: "40px",
                              padding: "6px 10px",
                            },
                          }}
                        />
                      </Grid>
                      {/* Editable Company Name Field */}
                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                          }}
                        >
                          Company Name
                        </InputLabel>
                        <TextField
                          type="text"
                          name="otherNames"
                          value={userData.otherNames}
                          onChange={handleChange}
                          fullWidth
                          placeholder="e.g., Akatsuki Corp"
                          disabled={isAssocitePayrollAdmin || isExternalPayrollAdmin}  
                          error={!!companyNameError}
                          helperText={
                            companyNameError ||
                            "This field is required (max 60 characters)"
                          }
                          sx={{
                            background: "white",
                            "& .MuiInputBase-root": {
                              maxHeight: "40px",
                              padding: "6px 10px",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                          }}
                        >
                          Email
                        </InputLabel>
                        <TextField
                          type="text"
                          name="email"
                          value={userData.email}
                          onChange={handleChange}
                          fullWidth
                          sx={{
                            background: "white",
                            "& .MuiInputBase-root": {
                              maxHeight: "40px",
                              padding: "6px 10px",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                          }}
                        >
                          Phone
                        </InputLabel>
                        <TextField
                          type="text"
                          name="telephoneno"
                          value={userData.telephoneno}
                          onChange={handleChange}
                          fullWidth
                          sx={{
                            background: "white",
                            "& .MuiInputBase-root": {
                              maxHeight: "40px",
                              padding: "6px 10px",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                          }}
                        >
                          Status
                        </InputLabel>
                        <Select
                          name="status"
                          value={userData.status}
                          onChange={handleChange}
                          fullWidth
                          sx={{ height: "40px", background: "white" }}
                        >
                          {userStatus.map((row) => (
                            <MenuItem
                              key={row.userstatus.statusID}
                              value={row.userstatus.statusID}
                            >
                              {row.userstatus.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                          }}
                        >
                          Country
                        </InputLabel>
                        <Autocomplete
                          options={getOptionsForSelect("country")}
                          getOptionLabel={(option) => option.label}
                          value={
                            getOptionsForSelect("country").find(
                              (opt) => opt.value === userData.countryid,
                            ) || null
                          }
                          onChange={(e, newValue) =>
                            setUserData((prev) => ({
                              ...prev,
                              countryid: newValue?.value || "",
                              stateid: "",
                            }))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select a Country"
                              fullWidth
                              sx={{
                                background: "white",
                                "& .MuiInputBase-root": { maxHeight: "40px" },
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          sx={{
                            fontWeight: "800",
                            color: "#6b7280",
                            fontFamily: "Nunito",
                            fontSize: "14px",
                          }}
                        >
                          State
                        </InputLabel>
                        <Autocomplete
                          options={stateOptions}
                          getOptionLabel={(option) => option.label}
                          value={
                            stateOptions.find(
                              (opt) => opt.value === userData.stateid,
                            ) || null
                          }
                          onChange={(e, newValue) =>
                            setUserData((prev) => ({
                              ...prev,
                              stateid: newValue?.value || "",
                            }))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select a State"
                              fullWidth
                              sx={{
                                background: "white",
                                "& .MuiInputBase-root": { maxHeight: "40px" },
                              }}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Box className="customerdetail-btn mt-4">
                      <BaseButton buttonText={"Update"} type="submit" />
                    </Box>
                  </form>
                  <Divider sx={{ my: 2, border: "1px solid #A6A6A6" }} />
                  {/* <Box>
                    <Typography>Add Roles</Typography>
                    <RoleAutocomplete userRoles={userRoles} role={role} setRole={setRole} handleAddRole={handleAddRole} selectedUser={selectedUser} />
                  </Box> */}
                  <Divider sx={{ my: 2, border: "1px solid #A6A6A6" }} />
                  <Box>
                    <Typography>Assigned Roles</Typography>
                    <Box
                      sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}
                    >
                      {Array.isArray(selectedUser?.["Securityuserrole"]) ? (
                        selectedUser["Securityuserrole"].length > 0 ? (
                          selectedUser["Securityuserrole"].map((role) => (
                            <Chip
                              key={role.roleid}
                              label={
                                userRoles.find(
                                  (r) => r.securityrole.roleid === role.roleid,
                                )?.securityrole.name
                              }
                              // onDelete={() => {
                              // setRoleToDelete(role.roleid);
                              // setConfirmModalOpen(true);
                              // }}
                              color="primary"
                            />
                          ))
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            No roles assigned.
                          </Typography>
                        )
                      ) : typeof selectedUser?.["Securityuserrole"] ===
                          "object" && selectedUser?.["Securityuserrole"] ? (
                        <Chip
                          key={selectedUser["Securityuserrole"].roleid}
                          label={
                            userRoles.find(
                              (r) =>
                                r.securityrole.roleid ===
                                selectedUser["Securityuserrole"].roleid,
                            )?.securityrole.name
                          }
                          // onDelete={() => {
                          // setRoleToDelete(selectedUser["Securityuserrole"].roleid);
                          // setConfirmModalOpen(true);
                          // }}
                          color="primary"
                        />
                      ) : (
                        <Typography variant="body2" color="textSecondary">
                          No roles assigned.
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              </BaseCard>
            )}
            <CustomAlert
              severity={alert.severity}
              show={alert.showAlert}
              header={alert.header}
              message={alert.message}
              onClick={() => {
                setAlert({ ...alert, showAlert: false });
                if (alert.severity === "success") handleClose();
              }}
              autoclose={alert.severity === "error" ? false : true}
            />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Box
            className="table-sizing"
            sx={{
              overflow: "auto",
              backgroundColor: "#ffffff",
              padding: "20px",
            }}
          >
            <Box
              className="d-flex justify-content-end switch-button-container pointer"
              onClick={handleTableChange}
            >
              <Box className="switch-button">{switchButtonText}</Box>
            </Box>
            {showData === "email" ? (
              <UserEmailTable emailData={emailData} />
            ) : (
              <SMStable smsData={smsData} />
            )}
          </Box>
        </TabPanel>
        {/* App Access tab kept commented as in original */}
      </Box>
      <BaseModal
        open={confirmModalOpen}
        handleClose={() => {
          setConfirmModalOpen(false);
          setRoleToDelete(null);
        }}
        headerText="Confirm Role Removal"
        width="30%"
        baseHeight="auto"
      >
        <Box sx={{ mt: 2 }}>
          <Typography sx={{ fontFamily: "Nunito", fontSize: "14px" }}>
            Are you sure you want to remove this role?
          </Typography>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}
          >
            <BaseButton
              buttonText="Cancel"
              onClick={() => {
                setConfirmModalOpen(false);
                setRoleToDelete(null);
              }}
              buttonStyle="save-button"
            />
            <BaseButton
              buttonText="Yes"
              onClick={handleConfirmDelete}
              buttonStyle="save-button"
            />
          </Box>
        </Box>
      </BaseModal>
    </BaseDrawer>
  );
}
const RoleAutocomplete = ({ userRoles, role, setRole, handleAddRole }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
      <Autocomplete
        fullWidth
        options={userRoles.map((role) => ({
          key: role.securityrole.roleid,
          value: role.securityrole.roleid,
          label: role.securityrole.name,
        }))}
        getOptionLabel={(option) => option.label || ""}
        value={
          userRoles
            .map((role) => ({
              key: role.securityrole.roleid,
              value: role.securityrole.roleid,
              label: role.securityrole.name,
            }))
            .find((opt) => opt.value === role) || null
        }
        onChange={(event, newValue) => setRole(newValue ? newValue.value : "")}
        sx={{ flexGrow: 1, "& .MuiInputBase-root": { height: "40px" } }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select a Role"
            variant="outlined"
            sx={{
              height: "40px",
              borderRadius: "4px",
              background: "white",
              "& .MuiInputBase-root": { height: "40px", padding: "6px 10px" },
            }}
          />
        )}
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "150px",
          height: "40px",
        }}
      >
        <BaseButton buttonText={"Add Role"} onClick={handleAddRole} />
      </Box>
    </Box>
  );
};
// ====================== CLEAN COMPANY NAME ======================
const cleanCompanyName = (raw) => {
  if (!raw) return "-";
  let name = String(raw)
    .replace(/&amp;amp;/g, "&")
    .replace(/&amp;#039;/g, "'")
    .replace(/&amp;#39;/g, "'")
    .replace(/&amp;/g, "&")
    .replace(/&#039;/g, "'")
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, "'")
    .replace(/&#34;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&nbsp;/g, " ")
    .trim();
  // Optional but highly recommended: extract real company name when it's prefixed like "code:&quot;name&quot;"
  if (name.includes(":")) {
    const parts = name.split(":");
    let extracted = parts[parts.length - 1].trim();
    extracted = extracted.replace(/^["']|["']$/g, ""); // remove wrapping quotes
    if (extracted) name = extracted;
  }
  return name || "-";
};

// ===============================================================
export default PayrollAdminModal;
